module.exports = __webpack_public_path__ + "img/pricing.fbd27e0e.svg";